<div class="form-input-indicators">
  <div class="form-line-item">
    <label class="form-line-item-label">
      <span [class.disabled]="isLoading || isValid" class="ep-text-regular-16">{{ title }}</span>
      <app-svg-icon
        *ngIf="info"
        [matTooltip]="info"
        matTooltipPosition="right"
        matTooltipClass="input-indicators-tooltip-text"
        class="icon-info"
        src="./assets/icons/ep_info_icon.svg"
      ></app-svg-icon>
      <div *ngIf="showNewStatus" class="align-end flex-row-direction">
        <app-svg-icon class="ellipse-icon" src="./assets/icons/ep_ellipse_216.svg"></app-svg-icon>
        <span class="new-status-text">{{ statusText }}</span>
      </div>
    </label>
    <mat-form-field appearance="outline" class="input-form-field" [ngClass]="{ 'mat-form-field-invalid': hasClientSideError && clientErrorStatus }">
      <input
        matInput
        [ngModel]="value"
        (ngModelChange)="setValue($event)"
        [disabled]="isLoading || isValid"
        (keyup.enter)="formInputSubmit()"
        type="text"
        class="input-outline"
        [placeholder]="inputPlaceholder"
      />
      <mat-hint *ngIf="hasClientSideError && clientErrorStatus" class="ep-text-regular-12 has-error">{{ clientErrorText }}</mat-hint>
      <span matSuffix *ngIf="isLoading" class="fa fa-circle-o-notch fa-spin spinner"> </span>
      <span matSuffix *ngIf="isValid">
        <app-svg-icon class="icon-validation" src="./assets/icons/check_input_validation.svg"></app-svg-icon>
      </span>
    </mat-form-field>
  </div>
  <div class="form-line-button">
    <button [disabled]="isLoading || isValid || value?.length === 0" (click)="formInputSubmit()" class="ep-btn ep-btn-compact button-arrow-right">
      <app-svg-icon class="icon-info" src="./assets/icons/arrow-right.svg"></app-svg-icon>
    </button>
  </div>
</div>
